export default {
  mobile: '@media all and (max-width: 768px)' as const
};
